import type { Site } from '@vista-digital/ocapi-types/v1'
import { getUnselectedSites, isNonEmptyArray } from '@vista-digital/occ-domain'
import type { OccI18N } from '@vista-digital/occ-ui'
import { siteCompareFn } from '@vista-digital/occ-ui/src/lib/components/site-picker/utils/site-utils'

export const getFilteredUnselectedSites = (
    siteIds: string[] | undefined,
    filteredSites: Site[] | undefined,
    i18n: OccI18N
) => {
    const getSitesToBeDisplayed = (unselectedSites: Site[], filterSiteIds?: string[]): Site[] => {
        if (!!filterSiteIds && filterSiteIds.length > 0) {
            unselectedSites = unselectedSites.filter(s => filterSiteIds.includes(s.id))
        }

        if (!!filterSiteIds && !filterSiteIds.length) return []

        if (!filteredSites) return unselectedSites

        return unselectedSites.filter(unselectedSite =>
            isNonEmptyArray(filteredSites.filter(filteredSite => unselectedSite.id === filteredSite.id))
        )
    }

    const unselectedSortedSites = getUnselectedSites()?.sort((siteA, siteB) => siteCompareFn(siteA, siteB, i18n)) || []

    return getSitesToBeDisplayed(unselectedSortedSites, siteIds)
}
